require('./services/api');
require('./services/account');
require('./services/careerLevel');
require('./services/code');
require('./services/countries');
require('./services/datetime');
require('./services/fnproductPacks');
require('./services/ftoAccounts');
require('./services/invoices');
require('./services/money');
require('./services/monthlyStatement');
require('./services/packet');
require('./services/payout');
require('./services/popup');
require('./services/recaptcha');
require('./services/royalBonuses');
require('./services/settings');
require('./services/status');
require('./services/statistics');
require('./services/terms');
require('./services/totalIncomes');
require('./services/transfer');
require('./services/user');
require('./services/verification');


// WEBPACK FOOTER //
// ./src/start.js